function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentsSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 36,
    width: 36,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#05A5EA"
    },
    cx: 256,
    cy: 220.68,
    r: 69.104
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#05A5EA"
    },
    d: "M365.408,423.912c-1.2-66.016-49.68-119.136-109.408-119.136s-108.224,53.136-109.408,119.136 H365.408z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#05A5EA"
    },
    cx: 82.192,
    cy: 140.008,
    r: 51.92
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#05A5EA"
    },
    d: "M164.4,292.696c-0.896-49.584-37.312-89.504-82.208-89.504S0.896,243.112,0,292.696H164.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#05A5EA"
    },
    cx: 429.792,
    cy: 140.008,
    r: 51.92
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#05A5EA"
    },
    d: "M512,292.696c-0.896-49.584-37.312-89.504-82.208-89.504s-81.296,39.92-82.208,89.504H512z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsSvgrepoCom);
export default __webpack_public_path__ + "static/media/students-svgrepo-com.f26f74f08d761f924812491b94b9e5b4.svg";
export { ForwardRef as ReactComponent };